module.exports = __webpack_public_path__ + "img/icon-2.2e3479af.png";